import React from 'react'

const MytFooter = () => {
  return (
    <div
        className="center mt-4"
    >
        <label> 
            Powered by MYT SofDev Solutions Inc. DreamTech 1.0.0
        </label>
    </div>
  )
}

export default MytFooter
